import { WifiOff } from "lucide-solid";
import { Show, createSignal, onCleanup, onMount } from "solid-js";

export function OfflineIndicator() {
  const [offline, setOffline] = createSignal(
    typeof navigator !== "undefined" && navigator.onLine === false,
  );

  onMount(() => {
    const onOnline = () => setOffline(false);
    const onOffline = () => setOffline(true);
    window.addEventListener("online", onOnline);
    window.addEventListener("offline", onOffline);
    onCleanup(() => {
      window.removeEventListener("online", onOnline);
      window.removeEventListener("offline", onOffline);
    });
  });

  return (
    <Show when={offline()}>
      <div
        role="status"
        aria-live="polite"
        class="fixed bottom-[calc(5rem_+_env(safe-area-inset-bottom,0px))] md:bottom-4 left-1/2 -translate-x-1/2 z-50 flex items-center gap-2 px-3 py-2 rounded-md bg-surface-2 border border-border-subtle shadow-lg text-label-sm text-text-muted"
      >
        <WifiOff size={14} class="text-brand shrink-0" />
        <span>Offline. Some data may be stale.</span>
      </div>
    </Show>
  );
}
